/**
 * Match moment().locale('en-US').startOf('week'): week starts Sunday.
 * Luxon's DateTime#startOf('week') follows ISO 8601 (Monday).
 *
 * @param {import('@calendly/datetime').DateTime} dt
 */
export const startOfUsWeekSunday = (dt) => {
  const { weekday } = dt
  return dt.minus({ days: weekday === 7 ? 0 : weekday }).startOf('day')
}
